import { render, staticRenderFns } from "./PasswordUserComponent.vue?vue&type=template&id=65672b43"
import script from "./PasswordUserComponent.vue?vue&type=script&lang=js"
export * from "./PasswordUserComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports